export default __webpack_public_path__ + "static/media/Gruesome_4@2x.685608c0.jpg";